import React, { PureComponent, Fragment } from 'react'
import classnames from 'classnames'

import Icon from '../Icon'
import Button from '../Button'

export class Banner extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      collapsed: true
    }
    this.toggleCollapse = this.toggleCollapse.bind(this)
  }

  toggleCollapse () {
    this.setState(state => ({
      collapsed: !state.collapsed
    }))
  }

  renderIcon () {
    const { type } = this.props

    switch (type) {
      case 'info':
        return (
          <Icon
            icon='snips-air-dots'
            className='blue icon icon--large icon--rotate-180'
          />
        )
      case 'warning':
        return (
          <Icon
            icon='info'
            className='white icon icon--large icon--rotate-180 mr2'
          />
        )
      default:
        return null
    }
  }

  renderCollapsible () {
    const { moreInfo } = this.props
    const { collapsed } = this.state

    if (!moreInfo) return null

    return (
      <Fragment>
        <Button
          className='button--unstyled flex items-center'
          onClick={this.toggleCollapse}
        >
          <Icon
            icon='caret-up'
            className={classnames('icon icon--small', {
              'icon--rotate-180': collapsed
            })}
          />
        </Button>
      </Fragment>
    )
  }

  render () {
    const {
      id,
      type,
      title,
      contentTitle,
      content,
      learnMoreLink,
      moreInfo,
      onClose
    } = this.props
    const { collapsed } = this.state

    return (
      <div className={'banner maxw-xxlarge mx-auto px2 small banner--' + type}>
        <div className='flex flex-wrap items-center justify-between'>
          <div className='flex flex-wrap items-center'>
            <div className='flex items-center p2'>
              {this.renderIcon()}
              <strong>{title}</strong>
            </div>

            <div className='flex flex-wrap items-center p2 mr2'>
              {contentTitle && (
                <span className='pr2 strong'>{contentTitle}</span>
              )}
              <span className='pr2'>{content}</span>
              <div className='flex items-center'>
                {learnMoreLink && (
                  <a className='link--plain underline pr2' href={learnMoreLink}>
                    Learn More
                  </a>
                )}
                {this.renderCollapsible()}
              </div>
            </div>
          </div>
          {onClose && (
            <Button
              className='button--plain button--plain--skip-padding flex items-center self-baseline full-height absolute right-0 top-0 p2'
              onClick={() => onClose(id)}
            >
              <Icon icon='cancel' className='icon icon--medium' />
            </Button>
          )}
        </div>
        {!collapsed &&
          moreInfo && (
            <pre style={{ whiteSpace: 'pre-wrap' }} className='p2 pb3'>
              {moreInfo}
            </pre>
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/banners/Banner.js